import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";

export const Nuvationconnect = () => {

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      bgcolor="white"
      position="relative"
      paddingBottom="40px"
      gap={{ xs: 2.5, md: 0 }}
      data-model-id="175:1815"
    >
      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "center", md: "flex-start" }}
        alignSelf={{ xs: "auto", md: "stretch" }}
        width={{ xs: "360px", md: "100%" }}
        sx={{ height: { xs: "auto", md: "100px" }, bgcolor: { xs: "transparent", md: "#c0e1ec" } }}
        borderRadius="100px"
        position="relative"
      >
        <Box
          component="img"
          src="/images/support/chat-bubble-end.svg"
          alt=""
          sx={{
            width: { xs: "41px", md: "52px" },
            height: { xs: "96px", md: "123px" },
            zIndex: 1,
          }}
          position="absolute"
          left={0}
          top={0}
        />

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          width={{ xs: "360px", md: "450px" }}
          alignSelf={{ xs: "auto", md: "stretch" }}
          sx={{ marginTop: { xs: "-10px", md: 0 }, padding: { xs: "20px 0", md: 0 }, zIndex: { xs: 1, md: 'unset' } }}
          overflow="hidden"
          borderRadius="100px"
          bgcolor="#e5dbec"
          position="relative"
        >
          <Typography
            width="370px"
            fontSize="18px"
            color="#0a404a"
            fontWeight="normal"
            textAlign="center"
            lineHeight="24.3px"
            marginBottom="0px"
            sx={{ marginTop: { xs: "-1px", md: 0 }, marginLeft: { xs: "-5px", md: 0 } }}
          >
            <Box component="span" fontWeight={800}>
              1-877-NUV-CON1 (1-877-688-2661)
              <br />
            </Box>
            <Box
              component="span"
              fontSize="17px"
              fontWeight={600}
              lineHeight="22.9px"
            >
              Monday-Friday, 8 AM-8 PM EST
            </Box>
          </Typography>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          width={{ xs: "330px", md: "450px" }}
          alignSelf={{ xs: "auto", md: "stretch" }}
          sx={{
            marginTop: { xs: "-10px", md: 0 },
            padding: { xs: "20px 0", md: 0 },
            overflow: { xs: "hidden", md: "visible" },
            borderRadius: { xs: "100px", md: 0 },
            bgcolor: { xs: "#c0e1ec", md: "transparent" },
          }}
          position="relative"
        >
          <Typography
            width="290px"
            fontSize="17px"
            color="#0a404a"
            fontWeight="normal"
            textAlign="center"
            lineHeight="22.9px"
            marginBottom="0px"
            sx={{ marginTop: { xs: "-1px", md: 0 } }}
          >
            <Box component="span" fontWeight={600}>
              Visit us at
            </Box>
            <Box
              component="span"
              fontSize="18px"
              fontWeight={600}
              lineHeight="24.3px"
            >
              {" "}
              <br />
            </Box>
            <Box
              color="#0a404a"
              component="a"
              fontSize="18px"
              fontWeight={800}
              lineHeight="24.3px"
              href="https://www.nuvationconnect.com/" target="_blank" data-tracking="body-cta-link"
              sx={{ textDecoration: "underline" }}
            >
              NuvationConnect.com
            </Box>
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};
